import * as React from "react"

import Layout from "../components/Layout"

const ProjectAmenities = () => {
  return (
    <Layout>
      <h2>Your Unit Selection ...</h2>

      <iframe
        title="Elevation_Chart"
        width="100%"
        height="600px"
        src="/ElevationChart.pdf#toolbar=0"
      ></iframe>
    </Layout>
  )
}

export default ProjectAmenities
